export const VARIANT = {
  HEADER: 'header',
  NO_SPACING: 'no-spacing',
  STRIP: 'strip',
  TILE: 'tile',
} as const;

export type VariantValue = (typeof VARIANT)[keyof typeof VARIANT];
